import React, { useState } from "react";
import ModuleAccessTable from "../components/ModuleAccessTable";
import ModuleAccessAddEditModal from "../components/ModuleAccessAddEditModal";
import { SearchBar } from "../../../../../common/APICommon";

const ModuleAccessTab = ({ user, data, searchData, updateAccess }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const onSave = async (form) => {
    // ... (Original Audit logic from EmployeeTransactionAccessModule)
    const auditEntries = [];
    const fieldsToTrack = [
      { key: "allowSkipApproval", label: "Allow Skip Approval" },
      { key: "isEmployeeTransactionProcessManager", label: "Process Manager" },
      { key: "isEmployeeTransactionAssignedEmployee", label: "Assigned Employee" }
    ];

    fieldsToTrack.forEach(field => {
      const oldValue = !!selectedItem[field.key] ? "Yes" : "No";
      const newValue = !!form[field.key] ? "Yes" : "No";
      if (oldValue !== newValue) {
        auditEntries.push({
          setupArea: "Employee Transaction Access",
          actionTaken: "update",
          field: `${selectedItem.description} - ${field.label}`,
          oldValue, newValue, dateSaved: new Date(), savedById: user.id
        });
      }
    });

    const res = await updateAccess(selectedItem.id, form, auditEntries);
    if (res.success) setIsModalOpen(false);
  };

  return (
    <div className="space-y-4">
      <SearchBar handleFilter={searchData} />
      <ModuleAccessTable
        data={data}
        onEdit={handleEdit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
      <ModuleAccessAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={onSave}
      />
    </div>
  );
};

export default ModuleAccessTab;